import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import AETService from "../../services/AETService";

let initialState = {
    results: [],
    isLoading: false,
    hasMore: false,
    error: null,
}
export const getAllAetResults = createAsyncThunk(
    'getAllAetResults',
    async ({page, limit, text}, {getState, rejectWithValue, dispatch}) => {
        try {
            const response = await AETService.getAETResults(page, limit, text);
            return response;
        } catch (error) {
            return rejectWithValue(error?.response?.data);
        }
    },
);

const aetResultsSlice = createSlice({
    name: 'aetResultsSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllAetResults.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getAllAetResults.fulfilled, (state, action) => {
                state.isLoading = false;
                state.results = action.payload.data;
                state.hasMore = action.payload.hasMore;
            })
            .addCase(getAllAetResults.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                state.results = [];
                state.hasMore = false;
            })
    }
});

export const {} = aetResultsSlice.actions;

export default aetResultsSlice.reducer;